var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_96)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2427 12L19.0711 9.17159C19.0711 9.17159 20.4853 7.75737 18.364 5.63606C16.2427 3.51475 14.8285 4.92895 14.8285 4.92895C14.8285 4.92895 12.7071 7.05027 11.2929 8.46448C9.87873 9.87869 9.87873 11.2929 10.5858 12",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75745 12L4.92902 14.8284C4.92902 14.8284 3.5148 16.2426 5.63613 18.364C7.75745 20.4853 9.17166 19.0711 9.17166 19.0711C9.17166 19.0711 10.9394 17.3033 12.3536 15.8891C13.7679 14.4749 14.1214 12.7071 13.4143 12",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconLink);
export default __webpack_public_path__ + "static/media/common_icon_link.2fb1119afb967b9c497ae19d1a21e843.svg";
export { ForwardRef as ReactComponent };